import queryString from 'query-string';

export const REQUEST_FACETED_ITEMS = 'REQUEST_FACETED_ITEMS';
export const SET_SELECTED_FACET = 'SET_SELECTED_FACET';
export const SET_CUSTOM_PRICE_RANGE = 'SET_CUSTOM_PRICE_RANGE';
export const CLEAR_CUSTOM_PRICE_RANGE = 'CLEAR_CUSTOM_PRICE_RANGE';
export const SHOW_MOBILE_FACETS = 'SHOW_MOBILE_FACETS';
export const HIDE_MOBILE_FACETS = 'HIDE_MOBILE_FACETS';
export const SHOW_MOBILE_FACET_PANEL = 'SHOW_MOBILE_FACET_PANEL';
export const HIDE_MOBILE_FACET_PANELS = 'HIDE_MOBILE_FACET_PANELS';
export const INITIALIZE_MOBILE_FACETS = 'INITIALIZE_MOBILE_FACETS';

export function requestFacetedItems(categoryId, facetName, facetValue, isSelected, qs = '', pushState = true, e,
                                    component, context) {
    return {
        type: REQUEST_FACETED_ITEMS,
        payload: {
            requestType: REQUEST_FACETED_ITEMS,
            requestStatus: 'MAKING_REQUEST',
            categoryId: categoryId,
            facetName: facetName,
            facetValue: facetValue,
            isSelected: isSelected,
            queryString: qs,
            queryObj: queryString.parse(qs),
            pushState: pushState
        },
        meta: {
            event: e,
            component: component,
            context: context
        }
    };
}

export function setSelectedFacet(selectedFacet, selectedFacetType, isSeeMoreSelected) {
    return {
        type: SET_SELECTED_FACET,
        payload: {
            selectedFacet: selectedFacet,
            selectedFacetType: selectedFacetType,
            isSeeMoreSelected: isSeeMoreSelected
        }
    };
}

export function setCustomPriceRange(updateKey, value) {
    return {
        type: SET_CUSTOM_PRICE_RANGE,
        payload: {
            [updateKey]: value,
            hasBeenEdited: true
        }
    };
}

export function clearCustomPriceRange() {
    return {
        type: CLEAR_CUSTOM_PRICE_RANGE,
        payload: {
            min: '',
            max: '',
            hasBeenEdited: false
        }
    };
}

export function showMobileFacets() {
    return {
        type: SHOW_MOBILE_FACETS
    };
}

export function hideMobileFacets() {
    return {
        type: HIDE_MOBILE_FACETS
    };
}

export function showMobileFacetPanel(facetType) {
    return {
        type: SHOW_MOBILE_FACET_PANEL,
        payload: {
            facetType: facetType
        }
    };
}

export function hideMobileFacetPanels() {
    return {
        type: HIDE_MOBILE_FACET_PANELS
    };
}

export function initializeMobileFacets() {
    return {
        type: INITIALIZE_MOBILE_FACETS
    };
}
